var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          staticClass: "userDialog",
          attrs: {
            title: "用户选择",
            width: "1000px",
            "close-on-click-modal": false,
            "append-to-body": true,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-container",
            { staticStyle: { height: "500px" } },
            [
              _c(
                "el-aside",
                { attrs: { width: "200px" } },
                [
                  _c(
                    "el-card",
                    { staticClass: "org" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入组织机构过滤",
                              size: "small",
                            },
                            model: {
                              value: _vm.filterText,
                              callback: function ($$v) {
                                _vm.filterText = $$v
                              },
                              expression: "filterText",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("el-tree", {
                        ref: "officeTree",
                        attrs: {
                          data: _vm.officeTreeData,
                          props: {
                            value: "id", // ID字段名
                            label: "name", // 显示名称
                            children: "children", // 子级字段名
                          },
                          "default-expand-all": "",
                          "highlight-current": "",
                          "node-key": "id",
                          "render-content": _vm.renderContent,
                          "filter-node-method": _vm.filterNode,
                          "expand-on-click-node": false,
                        },
                        on: { "node-click": _vm.handleNodeClick },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-container",
                [
                  _c(
                    "el-header",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "font-size": "12px",
                        height: "30px",
                      },
                    },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "searchForm",
                          attrs: {
                            size: "small",
                            inline: true,
                            model: _vm.searchForm,
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.refreshList()
                            },
                            submit: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "loginName" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "small",
                                  placeholder: "登录名",
                                  clearable: "",
                                },
                                model: {
                                  value: _vm.searchForm.loginName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "loginName", $$v)
                                  },
                                  expression: "searchForm.loginName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "small",
                                    icon: "el-icon-search",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.refreshList()
                                    },
                                  },
                                },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "small",
                                    icon: "el-icon-refresh-right",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.resetSearch()
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-main",
                    [
                      _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.loading,
                              expression: "loading",
                            },
                          ],
                          ref: "userTable",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.dataList,
                            size: "small",
                            border: "",
                            height: "calc(100% - 40px)",
                          },
                          on: {
                            "selection-change": _vm.selectionChangeHandle,
                            "sort-change": _vm.sortChangeHandle,
                          },
                        },
                        [
                          _vm.limit <= 1
                            ? _c("el-table-column", {
                                attrs: {
                                  "header-align": "center",
                                  align: "center",
                                  width: "50",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                label: scope.row.id,
                                                value:
                                                  _vm
                                                    .dataListAllSelections[0] &&
                                                  _vm.dataListAllSelections[0]
                                                    .id,
                                              },
                                              nativeOn: {
                                                change: function ($event) {
                                                  return _vm.getTemplateRow(
                                                    scope.$index,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_c("span")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  3937999144
                                ),
                              })
                            : _vm._e(),
                          _vm.limit > 1
                            ? _c("el-table-column", {
                                attrs: {
                                  type: "selection",
                                  "header-align": "center",
                                  align: "center",
                                  width: "50",
                                },
                              })
                            : _vm._e(),
                          _c("el-table-column", {
                            attrs: {
                              prop: "photo",
                              "header-align": "center",
                              align: "center",
                              label: "头像",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("img", {
                                      staticStyle: { height: "35px" },
                                      attrs: {
                                        src:
                                          scope.row.photo === ""
                                            ? "/static/img/avatar.png"
                                            : scope.row.photo,
                                      },
                                    }),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "loginName",
                              "header-align": "center",
                              align: "center",
                              sortable: "custom",
                              "min-width": "90",
                              label: "登录名",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              "header-align": "center",
                              align: "真实姓名",
                              sortable: "custom",
                              "min-width": "90",
                              label: "用户名",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "companyDTO.name",
                              "header-align": "center",
                              align: "center",
                              sortable: "custom",
                              "min-width": "110",
                              label: "所属机构",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "officeDTO.name",
                              "header-align": "center",
                              align: "center",
                              sortable: "custom",
                              "min-width": "110",
                              label: "所属部门",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "loginFlag",
                              "header-align": "center",
                              align: "center",
                              "min-width": "100",
                              label: "状态",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.loginFlag === "1"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "success",
                                            },
                                          },
                                          [_vm._v("正常")]
                                        )
                                      : scope.row.loginFlag === "0"
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "danger",
                                            },
                                          },
                                          [_vm._v("禁用")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c("el-pagination", {
                        attrs: {
                          "current-page": _vm.pageNo,
                          "page-sizes": [5, 10, 50, 100],
                          "page-size": _vm.pageSize,
                          total: _vm.total,
                          layout: "total, sizes, prev, pager, next, jumper",
                        },
                        on: {
                          "size-change": _vm.sizeChangeHandle,
                          "current-change": _vm.currentChangeHandle,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-aside",
                { attrs: { width: "200px" } },
                _vm._l(_vm.dataListAllSelections, function (tag) {
                  return _c(
                    "el-tag",
                    {
                      key: tag.id,
                      attrs: { closable: "", "disable-transitions": false },
                      on: {
                        close: function ($event) {
                          return _vm.del(tag)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(tag.name) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.doSubmit()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }